export default __webpack_public_path__ + "static/media/limbo_rear_shot_young.aefda4a3.jpg";